import { useRouter } from "vue-router"
import { unref, computed } from "vue"

export const useButton = (to, href, tag, loading, emit) => {
    const router = useRouter()

    const component = computed(() => {
        if (unref(to)) return "router-link"
        if (unref(href)) return "a"
        if (unref(tag)) return unref(tag)
        return "button"
    })

    const resolvedRoute = computed(() => {
        if (!unref(to)) return
        return router.resolve(unref(to)).href
    })

    const clickEvent = event => {
        if (unref(loading)) {
            event.preventDefault()
            return
        }
        emit("click", event)
    }

    return { component, resolvedRoute, clickEvent }
}
